<template>
     <el-dialog
     :title="title"
     :visible.sync="dialogVisible"
     width="45%"
     top="5vh"
    :show-close="true"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="closeDialog"
    :destroy-on-close="true"
    >
       <div class="panel">
           <el-form ref="form" :model="form" :rules="formRules" label-width="140px">
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="手机号" prop="account">
                            <el-input size="small" v-model="form.account" placeholder="请输入手机号"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="姓名" prop="name">
                            <el-input size="small" v-model="form.name" placeholder="输入姓名"></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="12">
                        <el-form-item label="手机号" prop="phoneNum">
                            <el-input size="small" v-model="form.phoneNum" placeholder="输入手机号"></el-input>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="12" v-if="!form.virtualUser">
                        <el-form-item label="角色" prop="role">
                            <el-select
                                v-model="form.role"
                                clearable
                                filterable
                                placeholder="请选择"
                                style="width:100%;"
                                size="small"
                            >
                                <el-option
                                v-for="item in roleList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="部门名称">
                            <el-select
                                v-model="form.departmentName"
                                clearable
                                filterable
                                placeholder="请选择"
                                style="width:100%;"
                                size="small"
                            >
                                <el-option
                                v-for="item in deptList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="虚拟用户">
                            <el-select
                                v-model="form.virtualUser"
                                clearable
                                filterable
                                placeholder="请选择"
                                style="width:100%;"
                                size="small"
                                @change="virtualUserChange"
                            >
                                <el-option
                                v-for="item in VirtualUserList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- <el-col :span="12" v-for="item in setList" :key="item._id">
                        <el-form-item :label="item.fieldName" :prop="item.fieldName" v-if="item.fieldType == '0'">
                            <el-input size="small" v-model="form[item.fieldName]" placeholder="请输入" style="width:100%;"></el-input>
                        </el-form-item>
                        <el-form-item :label="item.fieldName" :prop="item.fieldName" v-if="item.fieldType == '1'">
                            <el-input-number v-model="form[item.fieldName]" :step="0.01" controls-position="right"  :min="0"  style="width:100%;"
                                size="small"></el-input-number>
                        </el-form-item>



                        <el-form-item :label="item.fieldName" :prop="item.fieldName" v-if="item.fieldType == '2'">
                            <el-date-picker
                                v-model="form[item.fieldName]"
                                type="date"
                                placeholder="选择日期"
                                style="width:100%;"
                                value-format="yyyy-MM-dd"
                                size="small">
                            </el-date-picker>

                        </el-form-item>
                        <el-form-item :label="item.fieldName" :prop="item.fieldName" v-if="item.fieldType == '4'">
                             <el-upload
                            class="avatar-uploader"
                            action=""
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                          </el-upload>

                        </el-form-item>


                    </el-col> -->
                    <!-- <el-col :span="12">
                        <el-form-item label="绩效系数" prop="customName">
                            <el-input size="small" v-model="form.name6" placeholder="输入绩效系数"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="职位类型">
                            <el-select
                                v-model="form.orderSatus"
                                clearable
                                filterable
                                placeholder="请选择"
                                style="width:100%;"
                                size="small"
                            >
                                <el-option
                                v-for="item in orderStatusList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="基本工资" prop="customName">
                            <el-input-number v-model="form.num" :step="0.01" controls-position="right"  :min="0"  style="width:100%;"
                                size="small"></el-input-number>
                        </el-form-item>
                    </el-col>
                     <el-col :span="12">
                        <el-form-item label="五险一金扣除金额" prop="customName">
                            <el-input-number v-model="form.num" :step="0.01" controls-position="right"  :min="0"  style="width:100%;"
                                size="small"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="请假小时" prop="customName">
                            <el-input-number v-model="form.num" :step="0.1" controls-position="right"  :min="0" style="width:100%;"
                                size="small"></el-input-number>
                        </el-form-item>
                    </el-col>

                      <el-col :span="12">
                        <el-form-item label="请假1小时扣除金额" prop="customName">
                            <el-input-number v-model="form.num" :step="0.01" controls-position="right"  :min="0"  style="width:100%;"
                                size="small"></el-input-number>
                        </el-form-item>
                    </el-col>
                     <el-col :span="12">
                        <el-form-item label="入职时间" prop="customName">
                            <el-date-picker
                                v-model="form.date"
                                type="date"
                                placeholder="选择日期"
                                style="width:100%;"
                                size="small">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="发放工资次数" prop="customName">
                            <el-input-number v-model="form.num" :step="1" controls-position="right"  :min="0" style="width:100%;"
                                size="small"></el-input-number>
                        </el-form-item>
                    </el-col> -->
                </el-row>
                <FormItem :setList="setList" :form="form" :mode="mode" v-if="showChild"></FormItem>
           </el-form>


       </div>
       <div class="panel-bottom">
            <el-button size="small" type="default"  @click="closeDialog">取消</el-button>
            <el-button size="small" type="primary"  @click="handleSave">保存</el-button>
        </div>

    </el-dialog>
</template>
<script>
import { phoneRule} from '@/utils/regMatch';
import FormItem from "@/components/FormItem";
export default {
    name:'createUser',
    components:{
        FormItem
    },
    props:{
        diaVisible:{
            type:Boolean,
            default:false,
        },
        rowData:{
            type:Object,
            default:{},
        },
        deptList:{
            type:Array,
            default:[],
        },
        setList:{
            type:Array,
            default:[],
        }

    },
    watch:{
        diaVisible(newVal,oldVal){
          this.showChild = true;
          if(newVal){
              this.dialogVisible = newVal;
          }
        },
        rowData(newVal,oldVal){
            let str = JSON.stringify(newVal);
            if(str != "{}"){
                this.title="修改用户";
                this.form = JSON.parse(str);
                this.mode = 'edit';

            }else{
                this.title="创建用户";
                this.mode = 'create';
                this.form = {
                  virtualUser:false,
                };
            }
        }
    },
    data(){
        return{
            title:'创建用户',
            dialogVisible: false,
            form:{
                virtualUser:false,
            },
            formRules:{
                account:[
                  {required: true, validator: phoneRule,trigger: ['blur','change'],},
                ],
                name:[
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                ],
                phoneNum:[
                    {required: false, validator: phoneRule,trigger: ['blur','change'],},
                ],
                role:[
                    { required: true, message: '请选择角色', trigger: ['blur'] },
                ],

            },
            orderStatusList: [
                {
                    label: "自制",
                    value: "0"
                },
                {
                    label: "外购",
                    value: "1"
                },
                {
                    label: "委外",
                    value: "2"
                }
            ],
            VirtualUserList:[
                {
                    label: "是",
                    value: true
                },
                {
                    label: "否",
                    value: false
                },
            ],
            roleList:[
                // {
                //     label:"用户账号管理员",
                //     value:"用户账号管理员"
                // },
                {
                    label:"轻量管理员",
                    value:"轻量管理员"
                },
                {
                    label:"轻量生产人员",
                    value:"轻量生产人员"
                },
            ],
            virtualUser:'1',
            user:JSON.parse(window.localStorage.getItem('userdata')),
            imageUrl:"",
            mode:'create',
            showChild:true
        }
    },
    created(){
    },
    methods:{

        handleSave(){

            this.$refs["form"].validate((valid) => {

                if (valid) {
                    this.form.phoneNum = this.form.account;
                    let data = JSON.parse(JSON.stringify(this.form));
                    data.updater = this.user.name + '(' + this.user.account + ')';
                    if(this.title == "创建用户"){
                        data.creater = this.user.name + '(' + this.user.account + ')';
                    }
                    this.dialogVisible = false;
                    this.showChild = false;
                    this.$emit('save',data);
                }
            })


        },

        closeDialog(){
            setTimeout(() => {
              this.showChild = false;
              this.dialogVisible = false;
              this.$emit('close');
              // this.$parent.createProductPanVisible = false;
            }, 100);
        },
        virtualUserChange(val){
            // this.form['virtualUser'] = (val == '0')?true:false;
        },
    //     beforeAvatarUpload(file) {
    //           const isJPG = file.type === 'image/jpeg';
    //           const isLt2M = file.size / 1024 / 1024 < 2;

    //           if (!isJPG) {
    //             this.$message.error('上传头像图片只能是 JPG 格式!');
    //           }
    //           if (!isLt2M) {
    //             this.$message.error('上传头像图片大小不能超过 2MB!');
    //           }
    //           return isJPG && isLt2M;
    //     },
    //     handleAvatarSuccess(res, file) {
    //       this.imageUrl = URL.createObjectURL(file.raw);
    //     },

    }

}
</script>
<style scoped>
    .panel{
        /* width: 100%; */
        height: auto;
        max-height: 420px;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 0px 10px;
    }

    .panel-bottom{
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding-top: 20px;
        text-align: center;
    }
    .panel-bottom el-button{
        margin: 10px 0 0 10px;
    }


</style>



// WEBPACK FOOTER //
// src/views/systemSetting/userSys/createUser.vue